import React from 'react';
import {of} from 'rxjs';
import {tap} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';

export const questionGroups = ajax.cache("/question-group", 10 * ajax.MINUTES);

export function getQuestionGroups() {
  return questionGroups;
}

export function getQuestionGroup(groupId) {
  return ajax.getJson("/question-group/"+groupId);
}

export function createQuestionGroup(groupData) {
  return ajax.postJson("/question-group", groupData)
    .pipe(tap(questionGroups.clearCache));
}

export function modifyQuestionGroup(groupId, groupData) {
  return ajax.putJson("/question-group/"+groupId, groupData, {resultType: 'text'})
    .pipe(tap(questionGroups.clearCache));
}

export function deleteQuestionGroup(groupId) {
  return ajax.deleteJson("/question-group/"+groupId, undefined, {resultType: 'text'});
}

export function subscribeToQuestionGroup(WrappedComponent) {
  return function QuestionGroupEditor({groupId, ...props}) {
    let questionGroup = groupId ?
      getQuestionGroup(groupId) :
      of({
        description: "",
      });

    const SubscribedComponent = subscribeTo(questionGroup, 'group', WrappedComponent);

    return <SubscribedComponent {...props} />;
  };
}

export function getQuestion(questionId) {
  return ajax.getJson("/question/"+questionId);
}

export function subscribeToQuestion(WrappedComponent, ErrorComponent) {
  return function QuestionEditor({questionId, ...props}) {
    const SubscribedComponent = subscribeTo(getQuestion(questionId), 'question', WrappedComponent, ErrorComponent);

    return <SubscribedComponent {...props} />;
  };
}

export function searchQuestions(searchTerm, page, pageSize, showLoadingScreen = true) {
  const encodedSearch = encodeURIComponent(searchTerm);
  return ajax.getJson(`/questions/search?searchTerm=${encodedSearch}&page=${page}&size=${pageSize}`, {showLoadingScreen});
}

export function addQuestionGroupToQuestion(questionId, groupId) {
  return ajax.postJson("/question/"+questionId+"/groups/"+groupId, undefined);
}

export function removeQuestionGroupFromQuestion(questionId, groupId) {
  return ajax.deleteJson("/question/"+questionId+"/groups/"+groupId, undefined, {resultType: 'text'});
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/QuestionService.js